/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnChanges, type OnInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { I18nService } from '@dm/core';

import { type GuideConfig, type GuideItemE, FileSystemGuideService } from './file-system-guide.service';

export interface TextConfig {
    /**
     * 文本配置
     */
    label: string;
    /**
     * 位置标记   比如 xxx-{0}---{1} 文本。如果 0 表示已经配置，1 未配置 mark = [true.false]
     */
    mark: boolean[];
}

@Component({
    selector: 'app-file-system-guide',
    templateUrl: './file-system-guide.component.html',
    styleUrls: ['./file-system-guide.component.scss'],
})
export class FileSystemGuideComponent implements OnInit, OnChanges {
    @Input() vstoreId: string;
    /**
     * 显示的文本配置
     */
    @Input() textConfigs: TextConfig[];
    /**
     * 需要查询的服务
     */
    @Input() guideItems: GuideItemE[];

    @Output() onStart = new EventEmitter();
    @Output() onEnd = new EventEmitter<boolean>();

    contentList = [];

    ngInited = false;
    loading = true;

    constructor(
        public service: FileSystemGuideService,
        public i18nService: I18nService,
    ) { }

    ngOnInit(): void {
        this.init();
        this.ngInited = true;
    }

    ngOnChanges(): void {
        if (this.ngInited) {
            this.init();
        }
    }

    init(): void {
        this.onStart.emit();
        this.contentList = [];
        this.loading = true;
        this.service.getConfigureConfig(this.guideItems, this.vstoreId).subscribe((configs: GuideConfig[]) => {
            this.contentList = this.formatText(configs);
            this.loading = false;
            this.onEnd.emit(Boolean(this.contentList.length));
        });
    }

    formatText(configs: GuideConfig[]): any[] {
        // 匹配命中的是哪个文本
        const text = this.textConfigs.find(
            ({ mark = [] }) => mark.filter(Boolean).length === configs.filter((item) => item.configured).length,
        );

        if (!text) {
            return [];
        }

        // 分隔文本，添加按钮
        const contentList = [];
        // 如果xxx-{0}--xx{1} 需要插入到文本中的按钮，需要使用mark标记出位置
        if (text.mark) {
            text.label.split(/\{\d+\}/).forEach((section, index) => {
                contentList.push(section);
                // 找到第一个和标记相同的选项，插入到内容， 并删除。
                const i = configs.findIndex((item) => item && item.configured === text.mark[index]);
                contentList.push(configs[i]);
                configs[i] = undefined;
            });
        } else if (!configs[0].configured) {
            // mark未配置   在末尾添加立即配置按钮
            configs[0].label = this.i18nService.get('settings.userAndRole_task_addLDAPUser_configure_link');
            contentList.push(text.label, configs[0], this.i18nService.get('common.Punctuation_preiod'));
        }

        return contentList.filter(Boolean);
    }

    configure(config: GuideConfig): void {
        config.action(() => this.refresh());
    }

    refresh(): void {
        this.init();
    }
}
